export enum ElectoralAuthorizations {
  RicercaElettore = 'ELETTORALE.RICERCA.QUERY',
  VariazioneSezioneElettorale = 'ELETTORALE.VARIAZIONE.UPDATE',
  Ricerca3dXML = 'ELETTORALE.3DXML.QUERY',
  ElettoraleCecir = 'ELETTORALE.VALIDAZIONE.CECIR',
}

export const ElectoralAuthorizationsList = [
  ElectoralAuthorizations.RicercaElettore,
  ElectoralAuthorizations.VariazioneSezioneElettorale,
  ElectoralAuthorizations.Ricerca3dXML,
  ElectoralAuthorizations.ElettoraleCecir,
];
